<!-- src/components/AppFooter.vue -->
<template>
  <footer class="footer">
    <!-- ─────── BLOQUE SUPERIOR (GRIS) ─────── -->
    <div class="footer-top">
      <div class="container cols">
        <!-- AYUDA -->
        <div class="col">
          <h3>Ayuda</h3>
          <ul>
            <li>
              <router-link
                :to="{ path: '/', query: { assistant: '1' } }"
                @click="handleClick"
                >Asistente Virtual</router-link
              >
            </li>
            <li class="redes-title">Redes:</li>
            <li>
              <a
                href="https://www.facebook.com/profile.php?id=100086146676296&sk=about"
                target="_blank"
                >Facebook</a
              >
            </li>
            <li>
              <a href="https://www.instagram.com/rodasep_talca/" target="_blank"
                >Instagram</a
              >
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/rodasep-e-i-r-l-9573021a7/"
                target="_blank"
                >LinkedIn</a
              >
            </li>
          </ul>
        </div>

        <!-- NAVEGACIÓN -->
        <div class="col">
          <h3>Navegación</h3>
          <ul>
            <li>
              <router-link to="/" @click="handleClick">Inicio</router-link>
            </li>
            <li>
              <router-link to="/productos" @click="handleClick"
                >Productos</router-link
              >
            </li>
            <li>
              <router-link to="/agricola" @click="handleClick"
                >Rodamientos Agrícolas</router-link
              >
            </li>
            <li>
              <router-link to="/automotriz" @click="handleClick"
                >Rodamientos Automotrices</router-link
              >
            </li>
            <li>
              <router-link to="/industrial" @click="handleClick"
                >Rodamientos Industriales</router-link
              >
            </li>
            <li>
              <router-link to="/talca" @click="handleClick"
                >Local Talca</router-link
              >
            </li>
            <li>
              <router-link to="/curico" @click="handleClick"
                >Local Curicó</router-link
              >
            </li>
            <li>
              <router-link to="/linares" @click="handleClick"
                >Local Linares</router-link
              >
            </li>
            <li>
              <router-link to="/contactos" @click="handleClick"
                >Contáctanos</router-link
              >
            </li>
            <li>
              <router-link to="/nosotros" @click="handleClick"
                >Sobre Nosotros</router-link
              >
            </li>
          </ul>
        </div>

        <!-- CONTACTO -->
        <div class="col">
          <h3>Contacto</h3>
          <ul class="contacto-list">
            <li>
              <router-link to="/contactos" @click="handleClick">
                Email: a través de nuestro formulario de cotización
                <span class="nowrap"
                  >(¡estamos&nbsp;atentos para ayudarte!)</span
                >
              </router-link>
            </li>
            <li>
              <a href="https://wa.me/56989216528" target="_blank"
                >WhatsApp: +56&nbsp;9&nbsp;8921&nbsp;6528</a
              >
            </li>
            <li class="horario">
              <p><strong>Horario de atención:</strong></p>
              <p>
                <strong>Lunes a Viernes</strong> 09:00–18:00&nbsp;h (invierno)
              </p>
              <p>
                <strong>Sábado y Domingo:</strong> Responderemos el día hábil
                siguiente
              </p>
            </li>
          </ul>
        </div>
      </div>
      <!-- /.container -->
    </div>
    <!-- /.footer-top -->

    <hr class="divider" />

    <!-- ─────── BLOQUE INFERIOR (NEGRO) ─────── -->
    <div class="footer-bottom">
      <div class="container bottom-inner">
        <p class="legal">
          © TODOS LOS DERECHOS RESERVADOS<br />
          Rodasep.cl SPA, Casa Matriz en Calle 15 Oriente N.º 1016, Talca,
          Región del Maule, Chile.
        </p>
        <p class="legal">
          © 2025 Rodasep. Al utilizar este sitio aceptas nuestras Condiciones de
          Uso y Política de Privacidad. Las imágenes son referenciales. Los
          productos añadidos al carro de cotización no aseguran disponibilidad /
          precio; toda solicitud está sujeta a verificación de stock y valores
          por parte de nuestro equipo. Consultas sólo en
          <strong>www.rodasep.cl</strong>.
        </p>

        <!-- CREDITOS (ahora en columna) -->
        <div class="creditos">
          <span class="creditos-titulo">Diseñado y desarrollado por:</span>

          <a
            class="firma-github"
            href="https://github.com/FelipeDiazCampos"
            target="_blank"
            rel="noopener"
          >
            <img
              src="@/assets/images/logos/github.webp"
              alt="GitHub"
              class="github-3d"
            />

            <span class="firma-nombre">AlphaDíaz</span>
          </a>
        </div>

        <router-link class="logo-rodasep" to="/" @click="handleClick">
          <img
            src="@/assets/images/logos/white-logo.webp"
            alt="Rodasep – Venta de Repuestos Industriales"
          />
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

function handleClick(e) {
  const href = e.currentTarget.getAttribute("href");
  if (!href || !href.startsWith("/")) return;
  if (href === route.path) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    router.push(href).then(() => window.scrollTo({ top: 0 }));
  }
}
</script>

<style scoped>
/* ───────── CONFIG GENERAL ───────── */
.footer {
  background: #000000;
  color: #e5e5e5;
  font-family: "Playfair Display", serif;
  line-height: 1.55;
}
.container {
  max-width: 1320px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

/* ─────── BLOQUE SUPERIOR (gris) ─────── */
.footer-top {
  background: #2b2b2b;
}
.cols {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
}
.col {
  flex: 1 1 230px;
  min-width: 200px;
}
.col h3 {
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
  color: #fff;
}
.col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.col li {
  margin: 0.4rem 0;
}
a {
  color: #e5e5e5;
  text-decoration: none;
  transition: color 0.25s;
}
a:hover {
  color: #00a9e0;
}
.redes-title {
  margin-top: 0.75rem;
  font-weight: 600;
}

/* DIVISOR */
.divider {
  border: 0;
  height: 1px;
  background: #000000;
  margin: 0;
}

/* ─────── BLOQUE INFERIOR (negro) ─────── */
.footer-bottom {
  position: relative;
}
.bottom-inner {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding-bottom: 0.1rem;
}
.legal {
  font-size: 0.9rem;
  max-width: 1500px;
}

/* ---------- créditos ---------- */
.creditos {
  display: flex;
  flex-direction: column; /* <─ apila título y firma */
  gap: 0.1rem;
  align-items: flex-start; /* izquierda por defecto   */
  font-size: 0.85rem;
}
.creditos-roda {
  display: flex;
  flex-direction: column; /* <─ EXPERIMENTAL */
  gap: 0.6rem;
  align-items: flex-start; /* izquierda por defecto   */
}
.firma-github {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  text-decoration: none;
}
.github-3d {
  width: 30px;
  height: 30px;
}

/*CSS Credito AlphDiaz*/

/* 1) Asegúrate de que .firma-nombre tenga posición relativa */
.firma-nombre {
  font-weight: 600;
  color: #e5e5e5;
  transition: color 0.3s ease, text-shadow 0.3s ease;
  position: relative;
}

/* 2) Efecto base al hacer hover (cambia color y añade un glow ligero) */
.firma-github:hover .firma-nombre {
  color: #00ffcc;
  text-shadow: 0 0 5px #00ffcc, 0 0 10px #00ffcc, 0 0 20px #00ffcc;
}

/* 3) Dos pseudo-elementos que dibujan pequeños rayos alrededor y animan su opacidad/tamaño */
.firma-github:hover .firma-nombre::before,
.firma-github:hover .firma-nombre::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4px;
  height: 4px;
  background: #00ffcc;
  border-radius: 50%;
  /* Rayitos en ocho direcciones alrededor del punto central */
  box-shadow: -8px -8px 2px #00ffcc, 8px -8px 2px #00ffcc, -8px 8px 2px #00ffcc,
    8px 8px 2px #00ffcc, 0 -12px 2px #00ffcc, 0 12px 2px #00ffcc,
    -12px 0 2px #00ffcc, 12px 0 2px #00ffcc;
  transform: translate(-50%, -50%) scale(1);
  animation: spark 0.4s infinite alternate;
  opacity: 0;
}

/* 4) Pequeño desfase en el segundo pseudo-elemento para que no vayan simultáneos */
.firma-github:hover .firma-nombre::after {
  animation-delay: 0.2s;
}

/* 5) Animación que expande y desvanece los rayitos */
@keyframes spark {
  from {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  to {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.8);
  }
}
/*FIN del credito*/

/* logo Rodasep */
.logo-rodasep {
  position: absolute;
  right: 7rem;
  bottom: -1rem;
}
.logo-rodasep img {
  width: 160px;
  max-width: 45vw;
} /*Tamaño logo*/

/* RESPONSIVE */
@media (max-width: 768px) {
  .logo-rodasep {
    position: static;
    align-self: center;
    margin-top: 1rem;
  }
  .bottom-inner {
    align-items: center;
    text-align: center;
  }
  .creditos {
    align-items: center;
  }
  .cols {
    gap: 2rem;
  }
  .footer-top .col {
    text-align: center;
  }
}
</style>
